const origin = window.location.origin
const isDev = process.env.NODE_ENV === 'development'

export const urlAsr = isDev ? 'https://asr-dev.nanosemantics.ai/api/asr' : `${origin}/api/asr`

export const urlTTS = isDev ? 'https://asr-dev.nanosemantics.ai/api/tts' : `${origin}/api/tts`

export const webSocketUrl = isDev ? 'wss://asr-dev.nanosemantics.ai:443/ws' : `wss://${window.location.host}/api/asr/ws`

export const urlConsole = isDev ? 'https://asr-console-dev.nanosemantics.ai' : `${origin}/api/console`
